import {
  createSummaryCardsConfig,
  createDataGridConfig,
} from '../email-pulse-config-defaults';
import { EMAIL_PULSE_DEFINITIONS } from '../email-pulse-definitions/email-pulse-definitions';

/**
 * Configuration for Orders tab summary cards
 */
export const ordersSummaryCardsConfig = createSummaryCardsConfig(
  'ordersSummary',
  'OrdersSummaryCards',
);

/**
 * Configuration for Orders tab data grid
 */
const ordersGrid = createDataGridConfig(
  'emailTypeDisplay',
  EMAIL_PULSE_DEFINITIONS.emailTypeDisplay,
);
export const getOrdersDataGridColumns = ordersGrid.getColumns;
export const ordersColumnVisibilityModel = ordersGrid.columnVisibilityModel;
